import { useState, useEffect } from "preact/hooks";

const roomName = "lounge"
const pageBackgroundURL = "https://assets.swoogo.com/uploads/1344716-613f669e3b181.mp4";

const useMessage = (message, callback) => {
    const listener = e => {
        if (e.data === message) callback()
    }

    useEffect(() => {
        window.addEventListener('message', listener)
        return () => window.removeEventListener('message', listener)
    })
}

const Zoom = () => {
    const [isClosed, setIsClosed] = useState(false)

    useMessage('closed call', () => {setIsClosed(true)})

    return isClosed
        ? null
        : <iframe key="zoomMeeting" src="https://delltech.tkeventsregistration.com/privatescreeninglounge/zoom" style="position:absolute ; width:60.7%;  height:66.2% ; left:19.7% ; top:9.0% " />
}

const PacMan = () => {
    const [isOpen, setIsOpen] = useState(false)
    const toggleIsOpen = () => setIsOpen(!isOpen)
    useMessage("toggle pacman", toggleIsOpen)

    const width = 300
    return <div
        style={{
            position: "absolute",
            right: isOpen ? "0px" : `${-width}px`,
            height: "100%",
            top: "0%",
            width: `${width}px`,
            transition: "0.25s cubic-bezier(.19,1,.22,1) all",
            background: "rgb(38, 95, 155)"
        }}
    >
        <p
            onClick={() => {setIsOpen(false)}}
            style={{
                position: "absolute",
                left: "7px",
                top: "5px",
                color: "black",
                "font-size": "14px",
                "font-weight": 900,
                "text-shadow": "1px 0px 3px white, -1px 0px 3px white, 0 1px 3px white, 0 -1px 3px white",
                "z-index": 2,
                cursor: "pointer"
            }}
        >X</p>
        <iframe
            style={{position: "absolute", width: "100%", height: "100%", top: 0, left: 0}}
            src="https://tkevents.digitaservice.com/marketing/pacman/15014/app.html?projectid=6805787796127e87211a80275500981-6127e87211a83&lang=en"
        />
    </div>
}

const links = [
    { label: "exit", width: "8.5%", height: "11.3%", left: "-0.0%", top: "0.3%", href: "/lobby", isExternal: true },
    { label: "pac-man", width: "10.3%", height: "53.0% ", left: "0.8%",  top: "37.7%", title: "Play PacMan!", onClick: () => {window.postMessage("toggle pacman")} },
    { label: "trivia", width: "9.3%", height: "60.0% ", left: "10.8%",  top: "29.7%", href: "#trivia", title: "Play Trivia!"  },
    { label: "big-screen", width: "60.7%", height: "66.2%", left: "19.7%", top: "9.0%", href: "#big-screen" },
    { label: "screening", width: "13.2%", height: "71.2%", left: "80.8%", top: "19.4%", href: "https://digitalpro.tiff.net/film/dell-technologies-special-digital-private-screening", target: "blank", title: "Click here to access the TIFF Digital Screening" },
];

const extras = <><Zoom /><PacMan /></>

export default {
    extras,
    links,
    roomName,
    pageBackgroundURL,
    styles: "height: calc(100vw * 434.533/878)"
};

 